import { Navigate, NavLink, Route, Routes, useLocation, Link } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/auth';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import SellersList from './pages/SellersList';
import SellerNew from './pages/SellerNew';
import SellerEdit from './pages/SellerEdit';
import SchedulesList from './pages/SchedulesList';
import ScheduleEdit from './pages/ScheduleEdit';
import ProductsList from './pages/ProductsList';
import ProductEdit from './pages/ProductEdit';
import PriceConfigsList from './pages/PriceConfigsList';
import PriceConfigEdit from './pages/PriceConfigEdit';
import PriceImports from './pages/PriceImports';
import PublishLog from './pages/PublishLog';

function RequireAuth({ children }: { children: JSX.Element }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="container"><p className="muted">Загрузка…</p></div>;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return children;
}

function RequireRole({ role, children }: { role: 'admin' | 'seller'; children: JSX.Element }) {
  const { user } = useAuth();
  if (!user || user.role !== role) return <Navigate to="/" replace />;
  return children;
}

function Shell({ children }: { children: React.ReactNode }) {
  const { user, logout } = useAuth();
  return (
    <>
      <header className="top-bar">
        <div className="brand"><Link to="/">flowwow-opt</Link></div>
        <nav className="tabs">
          <NavLink to="/" end>Главная</NavLink>
          {user?.role === 'admin' && <NavLink to="/sellers">Продавцы</NavLink>}
          <NavLink to="/schedules">Расписания</NavLink>
          <NavLink to="/products">Товары</NavLink>
          <NavLink to="/prices/imports">Прайсы</NavLink>
          <NavLink to="/publish-log">Лог</NavLink>
        </nav>
        <div className="user-pill">
          <span className="muted">{user?.login} · {user?.role}</span>
          <button className="link-btn" onClick={() => logout()}>Выйти</button>
        </div>
      </header>
      <main>{children}</main>
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <RequireAuth>
              <Shell>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/sellers" element={<RequireRole role="admin"><SellersList /></RequireRole>} />
                  <Route path="/sellers/new" element={<RequireRole role="admin"><SellerNew /></RequireRole>} />
                  <Route path="/sellers/:id" element={<RequireRole role="admin"><SellerEdit /></RequireRole>} />
                  <Route path="/schedules" element={<SchedulesList />} />
                  <Route path="/schedules/new" element={<ScheduleEdit />} />
                  <Route path="/schedules/:id" element={<ScheduleEdit />} />
                  <Route path="/products" element={<ProductsList />} />
                  <Route path="/products/new" element={<ProductEdit />} />
                  <Route path="/products/:id" element={<ProductEdit />} />
                  <Route path="/prices/imports" element={<PriceImports />} />
                  <Route path="/prices/configs" element={<PriceConfigsList />} />
                  <Route path="/prices/configs/new" element={<PriceConfigEdit />} />
                  <Route path="/prices/configs/:id" element={<PriceConfigEdit />} />
                  <Route path="/publish-log" element={<PublishLog />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Shell>
            </RequireAuth>
          }
        />
      </Routes>
    </AuthProvider>
  );
}
